import { useFormik } from "formik";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import * as api from "helper/helper";
import toast from "react-hot-toast";
import { userFormValidate } from "../../../../helper/validate";
import { formikExtra } from "../../helperFunctions/helpers";

const ChangeCongeladoModal = forwardRef(
  ({ item, onOk, reloadUsuarios }, ref) => {
    const modalButtonRef = useRef();

    const [canSave, setCanSave] = useState(true);

    useImperativeHandle(ref, () => ({
      toggleModal: () => {
        formik?.resetForm();
        modalButtonRef.current.click();

        setCanSave(true);
      },
    }));

    let initialValues = {
      nivel: 0,
      mensaje: "",
    };

    if (item) {
      initialValues = {
        nivel: 0,
        mensaje: "",
      };
    }

    useEffect(() => {}, []);

    useEffect(() => {
      setCanSave(true);
    }, [item]);

    const formik = useFormik({
      initialValues,
      enableReinitialize: true,
      validate: userFormValidate,
      validateOnBlur: false,
      validateOnChange: false,
      onSubmit: async (values) => {},
    });

    const congelado = item?.congelado ?? false;

    return (
      <>
        {/*<!-- Button trigger modal -->*/}
        <button
          ref={modalButtonRef}
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdropChangeCongeladoLimit"
          hidden
        >
          Launch static backdrop modal
        </button>

        {/*<!-- Modal -->*/}
        <div
          className="modal fade"
          id="staticBackdropChangeCongeladoLimit"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropChangeCongeladoLimitLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="modal-title"
                  id="staticBackdropChangeCongeladoLimitLabel"
                >
                  Solicitar Cambio a {!congelado ? "Congelado" : "Descongelado"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                {/*<div className="alert alert-warning" role="alert">
                Ya existe una peticion de cambio de Nivel de <b>basico</b> a{" "}
                <b>Oro</b> en <b>Pendiente de aprobación.</b>
                <br />
                <small>
                  Si Aplica a una nuevo cambio de Nivel, la anterior se
                  cancelara
                </small>
              </div>*/}
                <form className="row" onSubmit={formik.handleSubmit}>
                  <div className="mb-3">
                    <div className="mb-3">
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          placeholder="Deja Mensaje para Revisión"
                          id="floatingTextarea2"
                          {...formik.getFieldProps("mensaje")}
                          {...formikExtra.upperCase("mensaje", formik)}
                          style={{ height: "100px" }}
                        ></textarea>
                        <label htmlFor="floatingTextarea2">Mensaje</label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  disabled={!canSave}
                  onClick={async () => {
                    const asociadoId = item.id;

                    const mode = !item.congelado ? "Congelar" : "Descongelar";
                    const text = !item.congelado ? "Congelado" : "Descongelado";
                    const toastId = toast.loading("Solicitando...");

                    const responseCrearSolicitud = await api
                      .asociadosSolicitudesCreate({
                        asociadoId: asociadoId,
                        tipoDeSolicitud: mode,
                        fecha: new Date().toJSON(),
                        mensaje: formik.values.mensaje,
                      })
                      .catch((e) => {
                        toast.dismiss(toastId);
                        if (e.esError && e.codigoError && e.mensaje) {
                          toast.error(
                            `Error al Solicitar Cambio ${text}. ${e.mensaje}`,
                          );
                          return;
                        }
                        toast.error(`Error al Solicitar cambio ${text}. `);
                      });

                    toast.dismiss(toastId);
                    if (!responseCrearSolicitud) return;
                    toast.success(
                      <b>Se realizo solicitud de cambio en Asociado</b>,
                    );

                    modalButtonRef.current.click();
                  }}
                >
                  Solicitar
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  },
);

export default ChangeCongeladoModal;
